export const CREATE_COLLECTION_ORDER_REQUEST = 'CREATE_COLLECTION_ORDER_REQUEST'
export const CREATE_COLLECTION_ORDER_SUCCESS = 'CREATE_COLLECTION_ORDER_SUCCESS'
export const CREATE_COLLECTION_ORDER_ERROR = 'CREATE_COLLECTION_ORDER_ERROR'
export const CREATE_COLLECTION_ORDER_RESET = 'CREATE_COLLECTION_ORDER_RESET'
